import { z } from 'zod';
import { AuditFieldsSchema, MoneyHufSchema, TenantIdSchema } from '../types/common.types';
import { PaginationQuerySchema } from '../types/pagination.types';

export const ProductSchema = z
  .object({
    id: z.string().uuid(),
    tenantId: TenantIdSchema,
    sku: z.string().min(1).max(64),
    altSku: z.array(z.string()).default([]),
    name: z.string().min(1).max(255),
    description: z.string().nullable(),
    categoryId: z.string().uuid().nullable(),
    unitPrice: MoneyHufSchema,
    vatRate: z.number().int().min(0).max(100),
    unit: z.string().max(16),
    isRentable: z.boolean().default(false),
    isActive: z.boolean().default(true),
    imageUrls: z.array(z.string().url()).default([]),
  })
  .merge(AuditFieldsSchema);
export type Product = z.infer<typeof ProductSchema>;

export const ProductListQuerySchema = PaginationQuerySchema.extend({
  search: z.string().optional(),
  categoryId: z.string().uuid().optional(),
  isRentable: z.coerce.boolean().optional(),
  isActive: z.coerce.boolean().optional(),
});
export type ProductListQuery = z.infer<typeof ProductListQuerySchema>;
